import { type ReactNode } from 'react';
import IconButton from '../IconButton/IconButton';
import './ZoomControl.css';

interface ZoomControlProps {
  zoomOutDisabled: boolean;
  zoomInDisabled: boolean;
  onZoomOut: () => void;
  onZoomIn: () => void;
  onFit: () => void;
  children?: ReactNode;
}

export default function ZoomControl({
  zoomOutDisabled,
  zoomInDisabled,
  onZoomOut,
  onZoomIn,
  onFit,
  children
}: ZoomControlProps) {
  return (
    <div className="ZoomControl">
      <div className="ZoomControl-zoomButtons">
        <IconButton
          label="Zoom out"
          icon="zoom-out"
          disabled={zoomOutDisabled}
          onClick={onZoomOut}
        />
        {children}
        <IconButton
          label="Zoom in"
          icon="zoom-in"
          disabled={zoomInDisabled}
          onClick={onZoomIn}
        />
      </div>
      <IconButton
        label="Zoom to fit"
        icon="arrow-enlarge-tag"
        onClick={onFit}
      />
    </div>
  );
}
